
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/refer-a-friend/thank-you",
      function () {
        return require("private-next-pages/refer-a-friend/thank-you/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/refer-a-friend/thank-you"])
      });
    }
  